"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RadioButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-radio-group .main-label {\n  display: flex;\n  height: 1.1875rem;\n  font-size: 0.875rem;\n  letter-spacing: 0.02rem;\n  font-family: \"OpenSansRegular\";\n  color: #161616;\n  text-align: left;\n  margin-bottom: 0.5rem;\n  font-weight: 600; }\n\n.bds-radio-group .horizontal-align {\n  display: flex; }\n\n.bds-radio-group .vertical-align {\n  flex-direction: column; }\n\n.bds-radio-group .radio-container {\n  display: flex;\n  height: 1.25rem;\n  margin-right: 1.5rem;\n  margin-bottom: 0.5rem; }\n  .bds-radio-group .radio-container:last-child {\n    margin-right: 0; }\n  .bds-radio-group .radio-container .radio-container-vertical {\n    margin-bottom: 0.5rem;\n    margin-right: 0rem; }\n  .bds-radio-group .radio-container .label-container {\n    font-size: 0.875rem;\n    letter-spacing: 0.02rem;\n    font-family: \"OpenSansRegular\";\n    color: #393939;\n    text-align: left;\n    margin: inherit; }\n  .bds-radio-group .radio-container .disable-label {\n    color: #c6c6c6; }\n  .bds-radio-group .radio-container .bds-radio-custom-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.125rem; }\n\n.bds-radio-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  appearance: none;\n  -webkit-appearance: none;\n  width: 14px;\n  height: 14px;\n  border: 0.0625rem solid #161616;\n  border-radius: 50%;\n  cursor: pointer;\n  vertical-align: middle;\n  background-color: #ffffff;\n  margin-top: 1px;\n  margin-bottom: 1px;\n  margin-right: 8px;\n  position: relative; }\n  .bds-radio-btn:hover, .bds-radio-btn:focus {\n    outline: 0.15625rem solid #007fe0; }\n  .bds-radio-btn:checked {\n    border-color: #161616;\n    background-color: #161616; }\n  .bds-radio-btn:before {\n    content: '';\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 6px;\n    height: 6px;\n    background: #ffffff;\n    border-radius: 50%; }\n  .bds-radio-btn:disabled {\n    border: 0.0625rem solid #8d8d8d;\n    cursor: default;\n    outline: none; }\n";
  var fileName = "compone_radio";
  var element = document.querySelector("style[data-sass-component='compone_radio']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var RadioGroup = function RadioGroup(_ref) {
  var _radioClass, _radioItemClass;

  var label = _ref.label,
      name = _ref.name,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? _constants.horizontal : _ref$direction,
      options = _ref.options,
      onChange = _ref.onChange;
  var radioClass = (_radioClass = {}, _defineProperty(_radioClass, _constants.classes.horizontalAlign, true), _defineProperty(_radioClass, _constants.classes.verticalAlign, direction === _constants.vertical), _radioClass);
  var radioItemClass = (_radioItemClass = {}, _defineProperty(_radioItemClass, _constants.classes.radioContainer, true), _defineProperty(_radioItemClass, _constants.classes.radioContainerVertical, direction === _constants.vertical), _radioItemClass);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.bdsRadioGroup
  }, label && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.mainLabel
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": _constants.testId,
    className: (0, _classnames.default)(_objectSpread({}, radioClass))
  }, options.map(function (_ref2, index) {
    var label = _ref2.label,
        value = _ref2.value,
        disabled = _ref2.disabled;
    var allProps = {
      name: name,
      onChange: onChange,
      selected: defaultValue === value,
      label: label,
      value: value,
      disabled: disabled
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "".concat(_constants.keyPrefix).concat(index),
      className: (0, _classnames.default)(_objectSpread({}, radioItemClass))
    }, /*#__PURE__*/_react.default.createElement(RadioButton, allProps));
  })));
};

var RadioButton = function RadioButton(_ref3) {
  var _radioLabelClass;

  var name = _ref3.name,
      label = _ref3.label,
      value = _ref3.value,
      disabled = _ref3.disabled,
      selected = _ref3.selected,
      onChange = _ref3.onChange;
  var radioLabelClass = (_radioLabelClass = {}, _defineProperty(_radioLabelClass, _constants.classes.labelContainer, true), _defineProperty(_radioLabelClass, _constants.classes.disableLabel, disabled), _radioLabelClass);

  var handleChange = function handleChange(e) {
    var _e$stopPropagation, _e$persist;

    if (disabled) return; // Wrap the event to prevent preventDefault misuse

    var safeEvent = _objectSpread(_objectSpread({}, e), {}, {
      preventDefault: function preventDefault() {
        console.warn('preventDefault() is disabled in RadioButton to avoid breaking selection behavior.');
      },
      stopPropagation: (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 ? void 0 : _e$stopPropagation.bind(e),
      persist: (_e$persist = e.persist) === null || _e$persist === void 0 ? void 0 : _e$persist.bind(e),
      target: _objectSpread(_objectSpread({}, e.target), {}, {
        value: value,
        name: name
      })
    });

    onChange === null || onChange === void 0 ? void 0 : onChange(safeEvent);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.bdsRadioCustomBtn
  }, /*#__PURE__*/_react.default.createElement("input", {
    role: _constants.radioType,
    type: _constants.radioType,
    id: "".concat(name).concat(value),
    name: name,
    value: value,
    className: _constants.classes.radioBtnStyle,
    disabled: disabled,
    checked: selected,
    onChange: handleChange
  }), label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "".concat(name).concat(value),
    className: (0, _classnames.default)(_objectSpread({}, radioLabelClass))
  }, label));
};

exports.RadioButton = RadioButton;
RadioGroup.propTypes = {
  label: _propTypes.default.node,
  name: _propTypes.default.string.isRequired,
  defaultValue: _propTypes.default.string,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.string.isRequired,
    disabled: _propTypes.default.bool
  })).isRequired,
  direction: _propTypes.default.oneOf([_constants.horizontal, _constants.vertical]),
  onChange: _propTypes.default.func.isRequired
};
var _default = RadioGroup;
exports.default = _default;